//libs
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

//styles
import { Heading, Label, Wrapper } from './styles';

//selectors
import {
  getTitle,
  getMetaTitle,
  getBannerImages,
  getFilterWithNames,
  getIsOfferPage,
} from 'shared/store/listingV2/selectors';
import { getDynamicPageTitle } from 'shared/store/dynamicPage/selector';

//components
import ProductCount from 'shared/layouts/Listing/Desktop/components/Layout/components/ProductCount';

const ALL_PRODUCTS_TEXT = 'All Products';

interface TitleInterface {
  isSticky: boolean;
  containerTop: number;
  isAllProducts?: boolean;
}

const OFFER = 'Offer';

const Title = ({ isSticky, containerTop, isAllProducts }: TitleInterface) => {
  const title = useSelector(getTitle);
  const metaTitle = useSelector(getMetaTitle);
  const bannerImages = useSelector(getBannerImages);
  const filterWithNames = useSelector(getFilterWithNames);
  const isOfferPage = useSelector(getIsOfferPage);
  const dynamicPageTitle = useSelector(getDynamicPageTitle);
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);

  useEffect(() => {
    if (filterWithNames.length > 0) setIsFiltersApplied(true);
    else setIsFiltersApplied(false);
  }, [filterWithNames, isSticky]);

  const getDisplayText = () => {
    let displayText = isOfferPage && !title ? OFFER : metaTitle || title;

    if (dynamicPageTitle) displayText = dynamicPageTitle;

    return displayText;
  };

  const isStickyContainer = isAllProducts || bannerImages.length === 0;

  const TitleElement: React.ReactNode = isAllProducts ? Label : Heading;

  if (isAllProducts && bannerImages.length === 0) return null;

  return (
    <Wrapper
      isSticky={isSticky}
      containerTop={containerTop}
      isStickyContainer={isStickyContainer}
      isFiltersApplied={isFiltersApplied}
      data-at="header"
    >
      <TitleElement data-at="plp-title">
        {isAllProducts ? ALL_PRODUCTS_TEXT : getDisplayText()}
      </TitleElement>
      {!isSticky && isStickyContainer && <ProductCount />}
    </Wrapper>
  );
};
export default memo(Title);
